import { FeatureItem } from 'src/types';

/**
 * Static featured items to display before API-fetched featured items
 * These are shown first in the carousel on the home page
 */
export const demoFeaturedItems: FeatureItem[] = [
  {
    id: '1d88879c-a8f6-484a-bd7a-5b2392356609',
    orgId: '1665719d-80f3-4165-849b-3ff63399aeeb',
    name: 'Napster26',
    type: 'Creation',
    category: 'my-creations',
    previewImageUrl:
      'https://napsteraimusic-dyewfxh4abb6ataq.z02.azurefd.net/users-content/organizations/1665719d-80f3-4165-849b-3ff63399aeeb/tracks/effe52c6-4306-4ce0-abfe-adc041ab597e-1_cover.png',
    previewVideoUrl:
      'https://napsteraimusic-dyewfxh4abb6ataq.z02.azurefd.net/aimusic/contributors/0618a946-4961-47b1-a977-8be9ff5eb6cb/0618a946-4961-47b1-a977-8be9ff5eb6cb_mobile.mp4',
    videoDesktopPreviewUrl:
      'https://napsteraimusic-dyewfxh4abb6ataq.z02.azurefd.net/aimusic/contributors/0618a946-4961-47b1-a977-8be9ff5eb6cb/0618a946-4961-47b1-a977-8be9ff5eb6cb_desktop_preview.jpg',
    videoMobilePreviewUrl:
      'https://napsteraimusic-dyewfxh4abb6ataq.z02.azurefd.net/aimusic/contributors/0618a946-4961-47b1-a977-8be9ff5eb6cb/0618a946-4961-47b1-a977-8be9ff5eb6cb_mobile_preview.jpg',
    description:
      'how reliance is rocking the scene in india and geo is innovating making peoples live better every day',
    albumArtUrl:
      'https://napsteraimusic-dyewfxh4abb6ataq.z02.azurefd.net/users-content/organizations/1665719d-80f3-4165-849b-3ff63399aeeb/tracks/effe52c6-4306-4ce0-abfe-adc041ab597e-1_cover.png',
    albumName: 'Napster26',
    likes: 0,
    contributors: [
      {
        id: '0618a946-4961-47b1-a977-8be9ff5eb6cb',
        givenName: 'Edo Segal',
        thumbnailUrl:
          'https://mentordata-acazgce6cvdzgng9.z02.azurefd.net/data/89c53581-368e-461f-8517-53d54179c638/df58628e-cdc0-4e64-b8c2-b1b0410c2587/d3d2f698-dcba-4585-a0ae-783d05d55e06/1a57bdbd2a02ff36429c141532c42ee9-1753952252520-selfie.png',
        videoDesktopUrl:
          'https://napsteraimusic-dyewfxh4abb6ataq.z02.azurefd.net/aimusic/contributors/0618a946-4961-47b1-a977-8be9ff5eb6cb/0618a946-4961-47b1-a977-8be9ff5eb6cb_desktop.mp4',
        videoMobileUrl:
          'https://napsteraimusic-dyewfxh4abb6ataq.z02.azurefd.net/aimusic/contributors/0618a946-4961-47b1-a977-8be9ff5eb6cb/0618a946-4961-47b1-a977-8be9ff5eb6cb_mobile.mp4',
      },
    ],
  },
];

/**
 * Demo contributor data for "edo-segal"
 * Used when navigating to /contributor/edo-segal
 */
export const demoContributorData = {
  id: 'edo-segal',
  givenName: 'Edo Segal',
  thumbnailUrl:
    'https://mentordata-acazgce6cvdzgng9.z02.azurefd.net/data/89c53581-368e-461f-8517-53d54179c638/df58628e-cdc0-4e64-b8c2-b1b0410c2587/d3d2f698-dcba-4585-a0ae-783d05d55e06/1a57bdbd2a02ff36429c141532c42ee9-1753952252520-selfie.png',
  videoDesktopUrl:
    'https://napsteraimusic-dyewfxh4abb6ataq.z02.azurefd.net/aimusic/contributors/0618a946-4961-47b1-a977-8be9ff5eb6cb/0618a946-4961-47b1-a977-8be9ff5eb6cb_desktop.mp4',
  videoMobileUrl:
    'https://napsteraimusic-dyewfxh4abb6ataq.z02.azurefd.net/aimusic/contributors/0618a946-4961-47b1-a977-8be9ff5eb6cb/0618a946-4961-47b1-a977-8be9ff5eb6cb_mobile.mp4',
  genre: ['Pop'],
  subGenre: ['Electronic'],
  type: 'Artist',
  likes: 0,
  gender: 'Male',
  age: 0,
  city: '',
  isLiked: false,
  albums: [
    {
      id: '1d88879c-a8f6-484a-bd7a-5b2392356609',
      orgId: '1665719d-80f3-4165-849b-3ff63399aeeb',
      name: 'Napster26',
      tracksCount: 1,
      thumbnailUrl:
        'https://napsteraimusic-dyewfxh4abb6ataq.z02.azurefd.net/users-content/organizations/1665719d-80f3-4165-849b-3ff63399aeeb/tracks/effe52c6-4306-4ce0-abfe-adc041ab597e-1_cover.png',
      duration: 180,
      locales: ['en'],
      isCreation: true, // Flag to identify this as a creation
    },
  ],
};
